module.exports = __webpack_public_path__ + "img/fr2.b461c4b1.jpg";